import * as React from "react";
const NotificationIcon = (props: React.SVGProps<SVGSVGElement>) => (
  <svg
    width={32}
    height={32}
    viewBox="0 0 32 32"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
    {...props}
  >
    <path
      d="M13.3542 25C14.0593 25.6224 14.9855 26 16 26C17.0144 26 17.9407 25.6224 18.6458 25M22 12C22 10.4087 21.3678 8.88258 20.2426 7.75736C19.1174 6.63214 17.5913 6 16 6C14.4087 6 12.8826 6.63214 11.7573 7.75736C10.6321 8.88258 9.99999 10.4087 9.99999 12C9.99999 15.0902 9.22046 17.206 8.34965 18.6054C7.61512 19.7859 7.24785 20.3761 7.26131 20.5408C7.27622 20.7231 7.31485 20.7926 7.46176 20.9016C7.59445 21 8.19258 21 9.38884 21H22.6111C23.8074 21 24.4055 21 24.5382 20.9016C24.6851 20.7926 24.7238 20.7231 24.7387 20.5408C24.7521 20.3761 24.3849 19.7859 23.6503 18.6054C22.7795 17.206 22 15.0902 22 12Z"
      stroke="#344054"
      strokeWidth={2}
      strokeLinecap="round"
      strokeLinejoin="round"
    />
  </svg>
);
export default NotificationIcon;
